import type { IntradayOrderRow } from '~/hooks/bidding/useListBiddingIntradayOrders'
import { isSameProtoDate, toProtoDate } from '~/models/dateTime'

/**
 * 要確認の警告 (AC-BIN-127) に出す件数。 表示中の受渡日の注文のうち、 取り込み元で
 * 見つからなくなった札 (`needsReview`) を数える。 AC-BIN-109a と同じく、 発注主体・
 * 画面の絞り込み・ステータスに依らない。
 */
export const intradayNeedsReviewCount = (
  orders: readonly IntradayOrderRow[],
  targetDate: Date,
): number => {
  const target = toProtoDate(targetDate)
  return orders.filter(
    (o) => o.needsReview && isSameProtoDate(o.targetDate, target),
  ).length
}
